<template>
    <div class="report">
        <table>

            <tr>
                <th class="th-first">BANK INFO</th>
                <th class="th-first">TOTAL Bill</th>
                <th class="th-end">WITH TAX</th>
            </tr>

            <tr>
                <td class="td-first">
                    <p>Date inssud:<span> 04 May 15 </span></p>
                    <p>Invoice No: <span>12321</span></p>
                </td>
                <td class="td-first td-by">$ {{totalPrice}}</td>
                <td class="td-end total-price">$ {{priceWithTax}}</td>
            </tr>

        </table>

        <div class="about">
            <p>{{this.messages}}</p>
        </div>

    </div>

</template>

<script>
    export default {
        props:{
            totalPrice:{},
            priceWithTax:{},
            messages:{}
        }
    }
</script>

<style scoped>
    .td-first{
        text-align: left;
    }




    .td-end{
        color: rgb(230, 40, 15);
        text-align: right;
    }

    .th-first{
        text-align: left;
    }

    .th-end{
        text-align: end;
    }

    .report{
        position: absolute;
        color: #111;
        width: 40%;
        left: 30%;
        background-color: rgb(209, 209, 209);
        padding: 0px 80px 0px 80px;

    }



    .report th{
        padding-top: 45px;
    }

    .report td{
        border-bottom: 1px solid rgba(70, 60, 60, 0.39);

    }
    .report tr{
        height: 70px;

    }

    .total-price{
        font-size: 18px;
        color: rgb(197, 17, 17);

    }

    .td-by{
        font-size: 18px;
    }

    .about{

        margin-top: 20px;
        margin-bottom: 50px;

    }

    .about p{
        font-size: 13px;
        font-weight: bold;

    }


    .report{
        position: absolute;
        color: #111;
        width: 40%;
        left: 30%;
        background-color: rgb(209, 209, 209);
        padding: 0px 80px 0px 80px;

    }

    .report th{
        padding-top: 45px;
    }

    .report td{
        border-bottom: 1px solid rgba(70, 60, 60, 0.39);

    }
    .report tr{
        height: 70px;

    }


    .total-price{
        font-size: 18px;
        color: rgb(197, 17, 17);

    }
    .about{

        margin-top: 20px;
        margin-bottom: 50px;

    }

    .about p{
        font-size: 13px;
        font-weight: bold;

    }

    th{
        color: rgb(70, 60, 60);
        border-bottom: 1px solid rgba(70, 60, 60, 0.39);
        font-weight: bold;
        font-size: 10px;
        height: 30px;
        padding-bottom: 3px;

    }

    td{
        padding-top: 20px;
        font-weight: bold;
        font-size: 11px;

    }
    .td-first{
        text-align: left;
    }




    .td-end{
        color: rgb(230, 40, 15);
        text-align: right;
    }


    table {
        width: 100%;
        border-collapse: collapse;

    }

    .th-first{
        text-align: left;
    }

    .th-end{
        text-align: end;
    }

    .td-by{
        font-size: 18px;
    }


</style>